<template>
  <div class="illegal">
    <fps-header
      class="header"
      :title="$t('upgrade_page_views_notice_illegal_index_2132')"
      backColor="black"
      color="#222C43"
      background="transparent"
    />
    <img src="./images/illegal.png" alt="" />
  </div>
</template>
<script>
export default {
  name: 'Illegal',
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.illegal {
  width: 100%;
  height: 100vh;
  overflow: auto;
  img {
    width: 100%;
    max-width: 100%;
  }
}
</style>
